// import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react';
// import { getAccessToken } from '../../../auth/keycloak';
import { GetCurrentSessionResponse, PostSessionMessagesResponse, ResetSessionRequest, ResetSessionResponse, GetSessionMessagesResponse, GetSessionMessagesRequest, PostSessionMessageRequest } from './api-models';
import { baseApi } from '../../../api/_base-api';

// const rawBaseQuery = fetchBaseQuery({
//     baseUrl: "/api",
// });

// function toHeaders(
//     input: Headers | string[][] | Record<string, string | undefined> | undefined
// ): Headers {
//     const headers = new Headers();

//     if (!input) {
//         return headers;
//     }

//     if (input instanceof Headers) {
//         input.forEach((value, key) => {
//             headers.set(key, value);
//         });
//         return headers;
//     }

//     if (Array.isArray(input)) {
//         for (const entry of input) {
//             if (entry.length >= 2) {
//                 const [key, value] = entry;
//                 if (typeof key === "string" && typeof value === "string") {
//                     headers.set(key, value);
//                 }
//             }
//         }
//         return headers;
//     }

//     for (const [key, value] of Object.entries(input)) {
//         if (typeof value === "string") {
//             headers.set(key, value);
//         }
//     }

//     return headers;
// }

// const baseQueryWithKeycloak: BaseQueryFn<
//     string | FetchArgs,
//     unknown,
//     FetchBaseQueryError
// > = async (args, api, extraOptions) => {
//     try {
//         const token = await getAccessToken();

//         const request: FetchArgs =
//             typeof args === "string" ? { url: args } : { ...args };

//         const headers = toHeaders(request.headers);
//         headers.set("authorization", `Bearer ${token}`);
//         request.headers = headers;

//         return await rawBaseQuery(request, api, extraOptions);
//     } catch (error) {
//         return {
//             error: {
//                 status: "CUSTOM_ERROR",
//                 error: error instanceof Error ? error.message : "Auth error",
//             },
//         };
//     }
// };


// export const interviewApi = createApi({
//     reducerPath: "interviewApi",
//     baseQuery: baseQueryWithKeycloak,
//     endpoints: (build) => ({
//         getCurrentSession: build.query<GetCurrentSessionResponse, void>({
//             query: () => ({
//                 url: "/v1/session/current",
//                 method: "GET",
//             }),
//         }),

//         getSessionMessages: build.query<
//             GetSessionMessagesResponse,
//             GetSessionMessagesRequest | void
//         >({
//             query: (args) => ({
//                 url: "/v1/session/messages",
//                 method: "GET",
//                 params: {
//                     limit: args?.limit,
//                     beforeMessageId: args?.beforeMessageId,
//                 },
//             }),
//         }),

//         postSessionMessage: build.mutation<
//             PostSessionMessagesResponse,
//             PostSessionMessageRequest
//         >({
//             query: (body) => ({
//                 url: "/v1/session/messages",
//                 method: "POST",
//                 body,
//             }),
//         }),

//         resetSession: build.mutation<ResetSessionResponse, ResetSessionRequest>({
//             query: (body) => ({
//                 url: "/v1/session/reset",
//                 method: "POST",
//                 body,
//             }),
//         }),
//     }),
// });


export const interviewApi = baseApi.injectEndpoints({
     endpoints: (build) => ({
    getCurrentSession: build.query<GetCurrentSessionResponse, void>({
      query: () => ({
        url: "/v1/session/current",
        method: "GET",
      }),
      providesTags: [{ type: "Session", id: "CURRENT" }],
    }),

    getSessionMessages: build.query<
      GetSessionMessagesResponse,
      GetSessionMessagesRequest | void
    >({
      query: (args) => ({
        url: "/v1/session/messages",
        method: "GET",
        params: {
          limit: args?.limit,
          beforeMessageId: args?.beforeMessageId,
        },
      }),
      providesTags: [{ type: "SessionMessages", id: "LIST" }],
    }),

    postSessionMessage: build.mutation<
      PostSessionMessagesResponse,
      PostSessionMessageRequest
    >({
      query: (body) => ({
        url: "/v1/session/messages",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "Session", id: "CURRENT" },
        { type: "SessionMessages", id: "LIST" },
      ],
    }),

    resetSession: build.mutation<ResetSessionResponse, ResetSessionRequest>({
      query: (body) => ({
        url: "/v1/session/reset",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "Session", id: "CURRENT" },
        { type: "SessionMessages", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false, 
});

export const {
  useGetCurrentSessionQuery,
  useGetSessionMessagesQuery,
  useLazyGetSessionMessagesQuery,
  usePostSessionMessageMutation,
  useResetSessionMutation,
} = interviewApi;